export default {"src":"/_next/static/media/ht.7a649a78.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};